import React from 'react'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import FormControl from '@mui/material/FormControl'
import InputLabel from '@mui/material/InputLabel'
import TextField from '@mui/material/TextField'
import Button from '@mui/material/Button'
import OutlinedInput from '@mui/material/OutlinedInput'
import Checkbox from '@mui/material/Checkbox'
import ListItemText from '@mui/material/ListItemText'
import IconButton from '@mui/material/IconButton'

import InspectObject from "./InspectObject";

// http://json-schema.org/understanding-json-schema/reference/index.html
const TYPES = 'string number integer object array boolean null'.split(' ')

export default function JsonSchemaBuilder({
  value,
  onChange,
}){
  const type = value?.type || ''

  const patch = changes =>
    onChange({...value, ...changes})

  return <Box>
    <FormControl fullWidth>
      <InputLabel>Type</InputLabel>
      <Select
        label="type"
        value={type}
        onChange={e => patch({ type: e.target.value })}
      >
        {TYPES.map(type =>
          <MenuItem key={type} value={type}>{type}</MenuItem>
        )}
      </Select>
    </FormControl>
    {type === 'object'
      ? <>
        <Box sx={{ml: 2}}>
          <Typography variant="h6">Properties:</Typography>
          <PropertiesInput
            value={value?.properties}
            onChange={properties => patch({ properties })}
          />
          <Typography variant="h6">Required:</Typography>
          <RequiredInput
            schema={value}
            value={value?.required}
            onChange={required => patch({ required })}
          />
        </Box>
      </>
      : null
    }
  </Box>
}


function PropertiesInput({value, onChange}){
  const patch = changes =>
    onChange({...value, ...changes})

  const addProperty = () => {
    const key = `new_property_${Date.now()}`
    patch({ [key]: {} })
  }
  return <Stack direction="column" spacing={2}>
    {Object.entries(value || {}).map(([name, spec]) =>
      <Box>
        <TextField fullWidth {...{
          label: 'Name',
          value: name,
          onChange(event){
            patch({
              [name]: undefined,
              [event.target.value]: spec
            })
          },
        }}/>
        <Box sx={{mt: 2, ml: 2}}>
          <JsonSchemaBuilder {...{
            value: spec,
            onChange(spec){ patch({ [name]: spec }) }
          }}/>
        </Box>
      </Box>
    )}
    <Button
      onClick={addProperty}
    >add new property</Button>
  </Stack>
}

function RequiredInput({ schema, value = [], onChange }){
  return <FormControl fullWidth>
    <InputLabel>Required Properties:</InputLabel>
    <Select
      multiple
      value={value}
      onChange={e => {
        let required = e.target.value || []
        if (typeof required === 'string') required = required.split(',')
        onChange(required)
      }}
      input={<OutlinedInput label="Tag" />}
      renderValue={selected => selected.join(', ')}
    >
      {Object.keys(schema?.properties || {}).map((name) => (
        <MenuItem key={name} value={name}>
          <Checkbox checked={value.includes(name)} />
          <ListItemText primary={name} />
        </MenuItem>
      ))}
    </Select>
  </FormControl>
}
